import type React from 'react';

export type LogLevel = 'info' | 'warning' | 'error' | 'success';

export interface ToastOptionsCompat {
  description?: string;
  duration?: number;
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
  className?: string;
  style?: React.CSSProperties;
}

export interface LogEventOptions {
  context: Record<string, unknown>;
  source?: string;
  showToast?: boolean;
  forceLog?: boolean;
  toastOptions?: ToastOptionsCompat;
}

export interface ILogger {
  info: (message: string, options?: LogEventOptions) => Promise<void>;
  warning: (message: string, options?: LogEventOptions) => Promise<void>;
  error: (message: string, options?: LogEventOptions) => Promise<void>;
  success?: (message: string, options?: LogEventOptions) => Promise<void>;
}

export interface LogAndToastParams extends Omit<LogEventOptions, 'context'> {
  message: string;
  level?: LogLevel;
  context?: Record<string, unknown>;
  toast?: boolean;
  toastOptions?: ToastOptionsCompat;
}

export type Ctx = Record<string, unknown>;

export type LogHelper = (
  message: string,
  source: string,
  context?: Ctx,
  showToast?: boolean,
  forceLog?: boolean
) => Promise<void>;
